/* esm.sh - es-toolkit@1.52.0/dist/predicate/isEqual */
import{noop as i}from"es-toolkit/dist/function/noop";import{isEqualWith as t}from"es-toolkit/dist/predicate/isEqualWith";function p(o,r){return t(o,r,i)}export{p as isEqual};
//# sourceMappingURL=isEqual.mjs.map